module.exports = __webpack_public_path__ + "img/parker-westport-card.b4ad8f1c.jpg";